import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const staffImessageReactionPayloadSchema = z
    .object({
        type: z.literal('staff_imessage_reaction').optional(),
        reaction: z.string(),
        sender_name: z.string().nullable().optional(),
        target_text_preview: z.string().nullable().optional(),
        sent_at: z.iso.datetime({ offset: true }).nullable().optional(),
        sent_at_timezone: z.string().nullable().optional(),
    })
    .strip();

export const staffImessageReactionDefinitions = {
    staff_imessage_reaction: defineInvisible('staff_imessage_reaction', {
        disposition: 'invisible',
        schema: staffImessageReactionPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const staffImessageReactionContractFixtures = {
    valid: {
        type: 'staff_imessage_reaction',
        reaction: 'acknowledged',
        sender_name: 'Internal staff name',
        target_text_preview: 'Internal message preview',
        sent_at: '2026-08-28T12:00:00Z',
        sent_at_timezone: 'America/New_York',
    },
    malformed: {
        type: 'staff_imessage_reaction',
        reaction: 7,
    },
} as const;
